import { render, staticRenderFns } from "./specialContent.vue?vue&type=template&id=c23f225e&scoped=true"
import script from "./specialContent.vue?vue&type=script&lang=js"
export * from "./specialContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23f225e",
  null
  
)

export default component.exports